import { MeasuresService } from "../service/asyncBatchMeasuresService";
import * as validations from "../utils/validations";

export class MeasuresFunctions {
  fnBurgissCalcUnfunded(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    return new MeasuresService().burgissCalcUnfunded(
      investId,
      endDate,
      baseorlocalcurrency,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }

  fnBurgissCalcValuation(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: string,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    rollForward = validations.validRFParam(rollForward);
    if (rollForward == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Roll Forward parameter";
    }

    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }

    return new MeasuresService().burgissCalcValuation(
      investId,
      endDate,
      baseorlocalcurrency,
      rollForward,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }

  fnBurgissCalcDistributions(
    investId: any[][],
    endDate?: any,
    currency?: string,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    return new MeasuresService().burgissCalcDistributions(
      investId,
      endDate,
      baseorlocalcurrency,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }

  fnBurgissCalcCommitment(
    investId: any[][],
    endDate?: any,
    currency?: string,
    filter?: any,
    idType?: string,
    selectionSetId?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);

    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    idType = validations.getIdType(idType);

    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    endDate = validations.isValidEndDate(endDate);

    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    // BeginDate = Validations.IsValidBeginDate(BeginDate);

    // if (BeginDate === false) {
    //   return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
    // }

    // dateCmp = Validations.dateCompare(BeginDate, endDate);
    // if (dateCmp == false) {
    //   return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    // }
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    filter = validations.isValidFilter(filter);

    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    return new MeasuresService().burgissCalcCommitment(
      investId,
      endDate,
      baseorlocalcurrency,
      filter,
      idType,
      selectionSetId,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }

  fnBurgissCalcStock(
    investId: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    const dateCmp = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }

    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new MeasuresService().burgissCalcStock(
      investId,
      endDate,
      baseorlocalcurrency,
      beginDate,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }

  fnBurgissCalcFees(
    investId: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    const dateCmp = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }

    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new MeasuresService().BurgissCalcFees(
      investId,
      endDate,
      baseorlocalcurrency,
      beginDate,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }

  fnBurgissCalcCash(
    investId: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    const basecurrrency = validations.validateBaseLocalCurrencyParam(currency);
    console.log(basecurrrency);
    if (basecurrrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternatebasecurrrency: string = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternatebasecurrrency.toString().includes("InvError")) {
      return alternatebasecurrrency.toString().replace("InvError ", "");
    }
    //const alternateBasecurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    // if (alternateBasecurrrency.includes("InvError")) {
    //   return "#INVALIDPARAMETERS - Invalid Currency parameter";
    // }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    const dateCmp = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }

    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new MeasuresService().BurgissCalcCash(
      investId,
      endDate,
      basecurrrency,
      beginDate,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternatebasecurrrency,
      uniqueCellId
    );
  }

  fnBurgissCalcIRR(
    investId: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: any,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    const basecurrrency = validations.validateBaseLocalCurrencyParam(currency);
    if (basecurrrency == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternatebasecurrrency: string = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternatebasecurrrency.toString().includes("InvError")) {
      return alternatebasecurrrency.toString().replace("InvError ", "");
    }

    rollForward = validations.validRFParam(rollForward);
    if (rollForward == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Roll Forward parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);
      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
      if (beginDate.year == 1) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
      const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
      if (dateCmp == false) {
        return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
      }
    }

    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }
    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }
    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new MeasuresService().BurgissCalcIRR(
      investId,
      endDate,
      basecurrrency,
      rollForward,
      beginDate,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternatebasecurrrency,
      uniqueCellId
    );
  }

  fnBurgissCalcRIRR(
    investId: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: any,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    const basecurrrency = validations.validateBaseLocalCurrencyParam(currency);
    if (basecurrrency == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternatebasecurrrency: string = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternatebasecurrrency.toString().includes("InvError")) {
      return alternatebasecurrrency.toString().replace("InvError ", "");
    }

    rollForward = validations.validRFParam(rollForward);
    if (rollForward == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Roll Forward parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);
      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
      if (beginDate.year == 1) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
      const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
      if (dateCmp == false) {
        return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
      }
    }

    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }
    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }
    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new MeasuresService().BurgissCalcRIRR(
      investId,
      endDate,
      basecurrrency,
      rollForward,
      beginDate,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternatebasecurrrency,
      uniqueCellId
    );
  }

  fnBurgissCalcDPI(
    investId: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    rollForward = validations.validRFParam(rollForward);
    if (rollForward == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Roll Forward parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    return new MeasuresService().BurgissCalcDPI(
      investId,
      endDate,
      baseorlocalcurrency,
      rollForward,

      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }

  fnBurgissCalcTVPI(
    investId: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new MeasuresService().BurgissCalcTVPI(
      investId,
      endDate,
      baseorlocalcurrency,
      rollForward,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }

  fnBurgissCalcRVPI(
    investId: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    rollForward = validations.validRFParam(rollForward);
    if (rollForward == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Roll Forward parameter";
    }

    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new MeasuresService().BurgissCalcRVPI(
      investId,
      endDate,
      baseorlocalcurrency,
      rollForward,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }

  fnBurgissCalcTWRR(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: string,
    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investid = validations.getSingleOrRangeValues(investid);

    if (String(investid) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    endDate = validations.isValidEndDate(endDate);

    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    currency = validations.validateBaseLocalCurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    rollForward = validations.validRFParam(rollForward);
    if (rollForward == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Roll Forward parameter";
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);

    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }

    return new MeasuresService().BurgissCalcTWRR(
      investid,
      endDate,
      currency,
      rollForward,
      beginDate,
      idType,
      selectionSetID,
      filter,
      advancedParameter,
      uniqueCellId
    );
  }

  fnBurgissCalcCostBasis(
    investid: any[][],
    beginDate?: any,
    endDate?: any,
    currency?: string,
    rollForward?: string,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investid = validations.getSingleOrRangeValues(investid);

    if (String(investid) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    rollForward = validations.validRFParam(rollForward);

    idType = validations.getIdType(idType);

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }

    if (rollForward == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Roll Forward parameter";
    }

    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }
    endDate = validations.isValidEndDate(endDate);

    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    currency = validations.validateBaseLocalCurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);

    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new MeasuresService().BurgissCalcCostBasis(
      investid,
      beginDate,
      endDate,
      currency,
      rollForward,
      idType,
      selectionSetID,
      filter,
      advancedParameter,
      uniqueCellId
    );
  }

  fnBurgissCalcFunding(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filters?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investid = validations.getSingleOrRangeValues(investid);

    if (String(investid) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    endDate = validations.isValidEndDate(endDate);

    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    currency = validations.validateBaseLocalCurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }

    filters = validations.isValidFilter(filters);

    if (filters == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }

    return new MeasuresService().BurgissCalcFunding(
      investid,
      endDate,
      currency,
      beginDate,
      idType,
      selectionSetID,
      filters,
      advancedParameter,
      uniqueCellId
    );
  }

  fnBurgissCalcPaidIn(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filters?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investid = validations.getSingleOrRangeValues(investid);

    if (String(investid) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    currency = validations.validateBaseLocalCurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }
    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }
    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }

    filters = validations.isValidFilter(filters);

    if (filters == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    return new MeasuresService().BurgissCalcPaidIn(
      investid,
      endDate,
      currency,
      beginDate,
      idType,
      selectionSetID,
      filters,
      advancedParameter,
      uniqueCellId
    );
  }

  fnBurgissCalcFundSize(
    investid?: any[][],
    endDate?: any,
    currency?: any,
    useAlternateFundSize?: any,
    uniqueCellId?: string
  ) {
    investid = validations.getSingleOrRangeValues(investid);

    if (String(investid) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    currency = validations.validateBaseLocalCurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    useAlternateFundSize = validations.validateAlternateFundSize(useAlternateFundSize);
    return new MeasuresService().BurgissCalcFundSize(investid, endDate, currency, useAlternateFundSize, uniqueCellId);
  }

  fnBurgissCalcCashOther(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filters?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investid = validations.getSingleOrRangeValues(investid);

    if (String(investid) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    idType = validations.getIdType(idType);

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }

    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }
    endDate = validations.isValidEndDate(endDate);

    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    currency = validations.validateBaseLocalCurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filters = validations.isValidFilter(filters);

    if (filters == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new MeasuresService().BurgissCalcCashOther(
      investid,
      endDate,
      currency,
      beginDate,
      idType,
      selectionSetID,
      filters,
      advancedParameter,
      uniqueCellId
    );
  }
  fnBurgissCalcCashReturnofCapital(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investid = validations.getSingleOrRangeValues(investid);

    if (String(investid) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    idType = validations.getIdType(idType);

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }

    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }
    endDate = validations.isValidEndDate(endDate);

    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    currency = validations.validateBaseLocalCurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);

    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new MeasuresService().BurgissCalcCashReturnofCapital(
      investid,
      endDate,
      currency,
      beginDate,
      idType,
      selectionSetID,
      filter,
      advancedParameter,
      uniqueCellId
    );
  }
  fnBurgissCashCapitalGains(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investid = validations.getSingleOrRangeValues(investid);

    if (String(investid) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    idType = validations.getIdType(idType);

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }
    endDate = validations.isValidEndDate(endDate);

    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    currency = validations.validateBaseLocalCurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);

    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new MeasuresService().BurgissCashCapitalGains(
      investid,
      endDate,
      currency,
      beginDate,
      idType,
      selectionSetID,
      filter,
      advancedParameter,
      uniqueCellId
    );
  }

  fnBurgissCalcCashIncome(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filters?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investid = validations.getSingleOrRangeValues(investid);

    if (String(investid) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    idType = validations.getIdType(idType);

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }
    endDate = validations.isValidEndDate(endDate);

    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    currency = validations.validateBaseLocalCurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }
    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }
    filters = validations.isValidFilter(filters);
    if (filters == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new MeasuresService().BurgissCalcCashIncome(
      investid,
      endDate,
      currency,
      beginDate,
      idType,
      selectionSetID,
      filters,
      advancedParameter,
      uniqueCellId
    );
  }

  fnBurgissCalcCashRecallableCapital(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investid = validations.getSingleOrRangeValues(investid);

    if (String(investid) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    idType = validations.getIdType(idType);
    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }
    endDate = validations.isValidEndDate(endDate);

    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    currency = validations.validateBaseLocalCurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);

    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new MeasuresService().BurgissCalcCashRecallableCapital(
      investid,
      endDate,
      currency,
      beginDate,
      idType,
      selectionSetID,
      filter,
      advancedParameter,
      uniqueCellId
    );
  }

  fnBurgissCalcDistributionsIncome(
    investId: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    const dateCmp = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }

    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }

    return new MeasuresService().burgissCalcDistributionsIncome(
      investId,
      endDate,
      baseorlocalcurrency,
      beginDate,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }

  fnBurgissCalcDistributionsReturnofCapital(
    investId: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }

    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    return new MeasuresService().burgissCalcDistributionsReturnofCapital(
      investId,
      endDate,
      baseorlocalcurrency,
      beginDate,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }

  fnBurgissCalcDistributionsCapitalgains(
    investId: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    const dateCmp = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }

    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    return new MeasuresService().burgissCalcDistributionsCapitalgains(
      investId,
      endDate,
      baseorlocalcurrency,
      beginDate,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }

  fnBurgissCalcDistributionsRecallableCapital(
    investId: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }

    idType = validations.getIdType(idType);
    if (idType == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }

    return new MeasuresService().burgissCalcDistributionsRecallableCapital(
      investId,
      endDate,
      baseorlocalcurrency,
      beginDate,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }

  fnBurgissCalcDistributionsOther(
    investId: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }

    idType = validations.getIdType(idType);
    if (idType == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    return new MeasuresService().burgissCalcDistributionsOther(
      investId,
      endDate,
      baseorlocalcurrency,
      beginDate,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissCalcValuationDate(
    investId?: any[][],
    endDate?: any,
    rollForward?: string,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    rollForward = validations.validRFParam(rollForward);
    if (rollForward == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Roll Forward parameter";
    }

    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    return new MeasuresService().burgissCalcValuationDate(
      investId,
      endDate,
      rollForward,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      uniqueCellId
    );
  }
  fnBurgissCalcAdjustedCommitment(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    return new MeasuresService().burgissCalcAdjustedCommitment(
      investId,
      endDate,
      baseorlocalcurrency,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissCalcNetCapitalContributed(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }
    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }

    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    return new MeasuresService().burgissCalcNetCapitalContributed(
      investId,
      endDate,
      baseorlocalcurrency,
      beginDate,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissCalcValuationRollForward(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    return new MeasuresService().burgissCalcValuationRollForward(
      investId,
      endDate,
      baseorlocalcurrency,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissCalcMIRR(
    investId?: any[][],
    financeIndexId?: any,
    financeIndexPremium?: any,
    reinvestmentIIndexId?: any,
    reinvestmentIIndexPremium?: any,
    endDate?: any,
    currency?: string,
    rollForward?: any,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    financeIndexId = validations.validIndexId(financeIndexId);
    if (financeIndexId == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for Finance IndexID parameter";
    }
    reinvestmentIIndexId = validations.validIndexId(reinvestmentIIndexId);
    if (reinvestmentIIndexId == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for Reinvestment IndexID parameter";
    }

    financeIndexPremium = validations.validPremiumValue(financeIndexPremium);
    if (financeIndexPremium == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for finance index premium parameter";
    } else {
      const resultPremium = validations.validPremiumRange(financeIndexPremium != "" ? financeIndexPremium : 0, -1, 1);
      if (resultPremium != "" && resultPremium.toString() == "0") {
        return "#INVALIDPARAMETERS - Premium should be in range between -1 to 1";
      }
    }
    reinvestmentIIndexPremium = validations.validPremiumValue(reinvestmentIIndexPremium);
    if (reinvestmentIIndexPremium == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for reinvestment index premium parameter";
    } else {
      const resultPremium = validations.validPremiumRange(
        reinvestmentIIndexPremium != "" ? reinvestmentIIndexPremium : 0,
        -1,
        1
      );
      if (resultPremium != "" && resultPremium.toString() == "0") {
        return "#INVALIDPARAMETERS - Reinvestment index premium should be in range between -1 to 1";
      }
    }
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    rollForward = validations.validRFParam(rollForward);
    if (rollForward == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Roll Forward parameter";
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }
    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    if (beginDate != null && rollForward.toString().toUpperCase() == "FALSE") {
      return "#INVALIDPARAMETERS - Roll Forward = False is not supported for point to point calculations";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    return new MeasuresService().burgissCalcMIRR(
      investId,
      financeIndexId,
      financeIndexPremium,
      reinvestmentIIndexId,
      reinvestmentIIndexPremium,
      endDate,
      baseorlocalcurrency,
      rollForward,
      beginDate,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }

  fnBurgissCalcLN_ICMIRR(
    investId?: any[][],
    index?: any,
    premium?: any,
    endDate?: any,
    currency?: string,
    rollForward?: any,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }

    premium = validations.validPremiumValue(premium);
    if (premium == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for premium parameter";
    } else {
      const resultPremium = validations.validPremiumRange(premium != "" ? premium : 0, -1, 1);
      if (resultPremium != "" && resultPremium.toString() == "0") {
        return "#INVALIDPARAMETERS - Premium should be in range between -1 to 1";
      }
    }
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    rollForward = validations.validRFParam(rollForward);
    if (rollForward == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Roll Forward parameter";
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    if (beginDate != null && rollForward.toString().toUpperCase() == "FALSE") {
      return "#INVALIDPARAMETERS - Roll Forward = False is not supported for point to point calculations";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    return new MeasuresService().burgissCalcLN_ICMIRR(
      investId,
      index,
      premium,
      endDate,
      baseorlocalcurrency,
      rollForward,
      beginDate,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissCalcLN_ICMIRRSpread(
    investId?: any[][],
    index?: any,
    premium?: any,
    endDate?: any,
    currency?: string,
    rollForward?: any,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }

    premium = validations.validPremiumValue(premium);
    if (premium == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for premium parameter";
    } else {
      const resultPremium = validations.validPremiumRange(premium != "" ? premium : 0, -1, 1);
      if (resultPremium != "" && resultPremium.ToString() == "0") {
        return "#INVALIDPARAMETERS - Premium should be in range between -1 to 1";
      }
    }
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    rollForward = validations.validRFParam(rollForward);
    if (rollForward == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Roll Forward parameter";
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    if (beginDate != null && rollForward.toString().toUpperCase() == "FALSE") {
      return "#INVALIDPARAMETERS - Roll Forward = False is not supported for point to point calculations";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    return new MeasuresService().burgissCalcLN_ICMIRRSpread(
      investId,
      index,
      premium,
      endDate,
      baseorlocalcurrency,
      rollForward,
      beginDate,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissCalcLN_ICMValuation(
    investId?: any[][],
    index?: any,
    premium?: any,
    endDate?: any,
    currency?: string,
    rollForward?: any,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }

    premium = validations.validPremiumValue(premium);
    if (premium == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for premium parameter";
    } else {
      const resultPremium = validations.validPremiumRange(premium != "" ? premium : 0, -1, 1);
      if (resultPremium != "" && resultPremium.toString() == "0") {
        return "#INVALIDPARAMETERS - Premium should be in range between -1 to 1";
      }
    }
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    rollForward = validations.validRFParam(rollForward);
    if (rollForward == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Roll Forward parameter";
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    if (beginDate != null && rollForward.toString().toUpperCase() == "FALSE") {
      return "#INVALIDPARAMETERS - Roll Forward = False is not supported for point to point calculations";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    return new MeasuresService().burgissCalcLN_ICMValuation(
      investId,
      index,
      premium,
      endDate,
      baseorlocalcurrency,
      rollForward,
      beginDate,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissCalcKS_PME(
    investId?: any[][],
    index?: any,
    premium?: any,
    endDate?: any,
    currency?: string,
    rollForward?: any,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }

    premium = validations.validPremiumValue(premium);
    if (premium == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for premium parameter";
    } else {
      const resultPremium = validations.validPremiumRange(premium != "" ? premium : 0, -1, 1);
      if (resultPremium != "" && resultPremium.toString() == "0") {
        return "#INVALIDPARAMETERS - Premium should be in range between -1 to 1";
      }
    }
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    const checkRollForward = validations.validRFParam(rollForward);
    if (checkRollForward == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Roll Forward parameter";
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    if (beginDate != null && rollForward.toString().toUpperCase() == "FALSE") {
      return "#INVALIDPARAMETERS - Roll Forward = False is not supported for point to point calculations";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    return new MeasuresService().burgissCalcKS_PME(
      investId,
      index,
      premium,
      endDate,
      baseorlocalcurrency,
      rollForward,
      beginDate,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissCalcGGS_DirectAlpha(
    investId?: any[][],
    index?: any,
    premium?: any,
    endDate?: any,
    currency?: string,
    rollForward?: any,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }

    premium = validations.validPremiumValue(premium);
    if (premium == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for premium parameter";
    } else {
      //const decimalCount = premium != "" ? "" : 0;
      const resultPremium = validations.validPremiumRange(premium != "" ? premium : 0, -1, 1);
      if (resultPremium != "" && resultPremium.toString() == "0") {
        return "#INVALIDPARAMETERS - Premium should be in range between -1 to 1";
      }
    }
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    rollForward = validations.validRFParam(rollForward);
    if (rollForward == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Roll Forward parameter";
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    if (beginDate != null && rollForward.toString().toUpperCase() == "FALSE") {
      return "#INVALIDPARAMETERS - Roll Forward = False is not supported for point to point calculations";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    return new MeasuresService().burgissCalcGGS_DirectAlpha(
      investId,
      index,
      premium,
      endDate,
      baseorlocalcurrency,
      rollForward,
      beginDate,
      idType,
      selectionSetId,
      filter,
      advancedParameter,
      alternateCurrrency,
      uniqueCellId
    );
  }
  //#endregion sathishkumar

  fnBurgissCalcCostBasisFXGainLoss(
    investid?: any[][],
    beginDate?: any,
    endDate?: any,
    currency?: string,
    rollForward?: string,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investid = validations.getSingleOrRangeValues(investid);

    if (String(investid) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    endDate = validations.isValidEndDate(endDate);

    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    currency = validations.validateBaseLocalCurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    rollForward = validations.validRFParam(rollForward);
    if (rollForward == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Roll Forward parameter";
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);

    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }

    return new MeasuresService().BurgissCalcCostBasisFXGainLoss(
      investid,
      endDate,
      currency,
      rollForward,
      beginDate,
      idType,
      selectionSetID,
      filter,
      advancedParameter,
      uniqueCellId
    );
  }

  fnBurgissCalcStockCapitalGains(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investid = validations.getSingleOrRangeValues(investid);

    if (String(investid) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    endDate = validations.isValidEndDate(endDate);

    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    currency = validations.validateBaseLocalCurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }
    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);

    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }

    return new MeasuresService().BurgissCalcStockCapitalGains(
      investid,
      endDate,
      currency,
      beginDate,
      idType,
      selectionSetID,
      filter,
      advancedParameter,
      uniqueCellId
    );
  }

  fnBurgissCalcStockCost(
    investid?: any[][],
    endDate?: any,
    currency?: string,

    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investid = validations.getSingleOrRangeValues(investid);

    if (String(investid) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    endDate = validations.isValidEndDate(endDate);

    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    currency = validations.validateBaseLocalCurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }
    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);

    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }

    return new MeasuresService().BurgissCalcStockCost(
      investid,
      endDate,
      currency,

      beginDate,
      idType,
      selectionSetID,
      filter,
      advancedParameter,
      uniqueCellId
    );
  }

  fnBurgissCalcStockRecallableCapital(
    investid?: any[][],
    endDate?: any,
    currency?: string,

    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investid = validations.getSingleOrRangeValues(investid);

    if (String(investid) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    endDate = validations.isValidEndDate(endDate);

    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    currency = validations.validateBaseLocalCurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }

    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);

    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }

    return new MeasuresService().BurgissCalcStockRecallableCapital(
      investid,
      endDate,
      currency,
      beginDate,
      idType,
      selectionSetID,
      filter,
      advancedParameter,
      uniqueCellId
    );
  }

  fnBurgissCalcStockReturnOfCapital(
    investid?: any[][],
    endDate?: any,
    currency?: string,

    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    advancedParameter?: string,
    uniqueCellId?: string
  ) {
    investid = validations.getSingleOrRangeValues(investid);

    if (String(investid) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    endDate = validations.isValidEndDate(endDate);

    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    currency = validations.validateBaseLocalCurrencyParam(currency);
    if (currency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }
    const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);

    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }

    return new MeasuresService().BurgissCalcStockReturnOfCapital(
      investid,
      endDate,
      currency,
      beginDate,
      idType,
      selectionSetID,
      filter,
      advancedParameter,
      uniqueCellId
    );
  }
}
